<template>
    <div class="seller-refund-form">
      <div class="common-header-wrap">
        <mt-header :title="'处理'+title" class="common-header">
          <mt-button slot="left" icon="back" @click="$router.go(-1)"></mt-button>
        </mt-header>
      </div>

      <div class="form">
          <flex-line :show-border="true">
          <span>{{'同意'+title}}</span>
          <div slot="right">
              <mt-radio
                      v-model="seller_state"
                      :options="seller_state_options">
              </mt-radio>
          </div>
          </flex-line>
          <flex-line v-if="refund_type==2" :show-border="true">
          <span>弃货</span>
          <div slot="right">
              <mt-radio
                      v-model="return_type"
                      :options="return_type_options">
              </mt-radio>
          </div>
          </flex-line>
          <flex-line class="field-line menu-item" :show-border="true"><span class="field-name">备注信息</span><div class="field-line-right" slot="right"><input class="field-input" type="textarea" v-model="seller_message" /></div></flex-line>

        <div class="pt-10 pb-10"><div class="common-btn ds-button-large" @click="submitInformation">保存</div></div>
      </div>
    </div>
</template>

<script>

import { Toast } from 'mint-ui'

import { editRefund } from '../../../api/sellerRefund'
import flexLine from '../../flexLine'
export default {
  components:{

  flexLine,

  },
  name: 'SellerRefundForm',
  data () {
    return {
      refund_id: this.$route.query.refund_id,
      seller_message: '',
      seller_state: '2',
      refund_type: this.$route.query.refund_type,
      title: this.$route.query.refund_type == 2 ? '退货' : '退款',
      return_type: '2',
      return_type_options: [
        {
          label: '是',
          value: '1'
        },
        {
          label: '否',
          value: '2'
        }
      ],
      seller_state_options: [
        {
          label: '是',
          value: '2'
        },
        {
          label: '否',
          value: '3'
        }
      ]
    }
  },
  mounted () {

  },
  computed: {

  },
  created: function () {

  },

  methods: {

    submitInformation () {
      editRefund(this.refund_id, this.return_type, this.seller_message, this.seller_state).then(res => {
        Toast(res.message)
        this.$router.go(-1)
      }).catch(function (error) {
        Toast(error.message)
      })
    }

  }
}
</script>
<style lang="scss">
    .seller-refund-form{
        .mint-radiolist {
            display: flex;
            .mint-cell {
                flex: 1;
                .mint-radio-input:checked + .mint-radio-core {
                    background-color: $primaryColor !important;
                    border-color: $primaryColor !important;
                }
                &:after{display: none}
            }
        }
    }
</style>
<style  lang="scss" scoped>
.form{background: #fff;padding:0 $pageSpace}
  .seller-refund-form {
    background: #fff;

    .menu-item {
    }
  }


</style>
